import experiments from '../../common/constants/experiments'

export default {
  name: 'CodeCanyon',
  abbreviation: 'CC',
  domain: 'codecanyon.net',
  google_analytics_id: 'UA-11834194-12',
  google_remarketing_label: 'bdtlCM3-uQMQp-WC_AM',
  item_results_layout: 'list',
  home_search_placeholder: 'e.g. ecommerce plugin',
  assets_domains: {
    item_thumbnail: 'thumb-cc.s3.envato.com',
    item_image: 'image-cc.s3.envato.com'
  },
  experiments_to_features: {
    [experiments.codecanyonCollapsedFilters]: {
      0: {
        'filters:collapsed': false
      },
      1: {
        'filters:collapsed': false
      },
      2: {
        'filters:collapsed': true
      },
      3: {
        'filters:collapsed': true
      }
    },
    [experiments.codecanyonFilterOrder]: {
      0: {
        'filters:customOrder': false
      },
      1: {
        'filters:customOrder': false
      },
      2: {
        'filters:customOrder': true
      },
      3: {
        'filters:customOrder': true
      }
    }
  },
  features: {
    'collapsedFilters:enrolment': false,
    'filterOrder:enrolment': true,
    'filters:collapsed': false,
    'filters:customOrder': false,
    'experiments:loading-cover': true
  },
  feeds_categories: [
    '/category/javascript',
    '/category/php-scripts',
    '/category/net',
    '/category/wordpress',
    '/category/plugins',
    '/category/css',
    '/category/html5',
    '/category/mobile',
    '/category/apps',
    '/category/skins',
    '/category/edge-animate-templates'
  ],
  filterOrder: [
    'category',
    'tags',
    'price',
    'software-version',
    'compatible-with',
    'sales',
    'rating',
    'date-added'
  ]
}
